// ConversationPage.tsx

import React, { useState, useEffect } from "react";
import {
  Conversation,
  Message,
  RightSidebarTab,
  Task,
} from "./components/Types";
import { ConversationSidebar } from "./components/ConversationList";
import { ChatArea } from "./components/ChatArea";
import { RightSidebar } from "./components/QuickActionsSidebar";
import ConversationData from "./components/data";

const ConversationPage: React.FC = () => {
  const { conversations, getMessages, messages, loading,messagesLoading } =
    ConversationData();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeConversation, setActiveConversation] =
    useState<Conversation | null>(null);
  const [activeRightTab, setActiveRightTab] =
    useState<RightSidebarTab>("tasks");
  const [searchTerm, setSearchTerm] = useState("");

  // --- HANDLERS ---
  const handleConversationClick = (conversation: Conversation) => {
    setActiveConversation(conversation);
    getMessages(conversation?.contactId?._id)
    // setMessages(sampleMessages[conversation._id] || []);
    // Reset sidebar state on new conversation click
    setIsSidebarOpen(false);
    setActiveRightTab("info"); // Default to 'info' when a new conversation is opened
  };

  // Handler to toggle sidebar visibility and ensure a default tab is selected when opening
  const handleQuickActionsClick = () => {
    setIsSidebarOpen((prev) => {
      // If sidebar is about to open, default to the 'tasks' tab.
      if (!prev) {
        setActiveRightTab("tasks");
      }
      return !prev;
    });
  };


  const filteredConversations = conversations.filter((conv: any) =>
    `${conv.contactId?.firstName} ${conv.contactId?.lastName}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flex h-[calc(100vh_-_theme('spacing.10')_*_6)] xl:min-h-[calc(100vh_-_theme('height.header')_*_2.4)] xl:h-[calc(100%_-_theme('spacing.5'))] bg-gray-100 dark:bg-gray-900 font-sans">
      {/* 1. Conversation List Sidebar */}
      <ConversationSidebar
        conversations={filteredConversations}
        activeConversation={activeConversation}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleConversationClick={handleConversationClick}
      />

      {/* 2. Main Chat Area */}
      <ChatArea
        activeConversation={activeConversation}
        messages={messages}
        isSidebarOpen={isSidebarOpen}
        handleQuickActionsClick={handleQuickActionsClick}
      />

      {/* 3. Right Sidebar for Quick Actions/Info */}
      {isSidebarOpen && activeConversation && (
        <RightSidebar
          activeConversation={activeConversation}
          activeRightTab={activeRightTab}
          setActiveRightTab={setActiveRightTab}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      )}
    </div>
  );
};

export default ConversationPage;
